__webpack_require__.p = "/nft-art/";